/**
 * G21 contextual WhatsApp funnel.
 * Builds a fresh message at click time with product, quantity and every selected option.
 */
(() => {
  'use strict';

  const N = (window.G21Perfect ||= {});
  if (N.whatsapp) return;

  const escapeRegExp = (value) => String(value).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

  const getQuantity = (controller) => {
    const scope = controller?.section || document;
    const input = scope.querySelector(
      'product-form input[name="quantity"], .buy-buttons-block input[name="quantity"], quantity-selector input, input[name="quantity"]'
    );
    const quantity = Number.parseInt(input?.value || '1', 10);
    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  };

  const getSelections = (controller) => {
    const selections = N.variants?.selections(controller) || {};
    return Object.fromEntries(
      Object.entries(selections)
        .map(([name, value]) => [String(name).trim(), String(value).trim()])
        .filter(([name, value]) => name && value && value !== '-')
    );
  };

  const formatOptions = (selections) => {
    const entries = Object.entries(selections);
    return entries.length ? entries.map(([name, value]) => `${name}: ${value}`).join('\n') : '-';
  };

  const buildUrl = (controller, link) => {
    const phone = (link.href.match(/wa\.me\/(\d+)/)?.[1] || '905334619373').replace(/\D/g, '');
    const selections = getSelections(controller);
    const find = (pattern) => Object.entries(selections).find(([name]) => pattern.test(name))?.[1] || '-';
    const quantity = getQuantity(controller);

    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set('utm_source', 'whatsapp');
    currentUrl.searchParams.set('utm_medium', 'cta');
    currentUrl.searchParams.set('utm_campaign', 'product_page');
    currentUrl.searchParams.set('utm_content', link.dataset.source || 'product');

    const values = {
      product: controller.productData?.productTitle || controller.section.querySelector('h1')?.textContent?.trim() || '',
      color: find(/color|renk/i),
      size: find(/size|beden/i),
      length: find(/length|boy/i),
      train: find(/train|kuyruk/i),
      quantity,
      options: formatOptions(selections),
      intent: link.dataset.intent || '',
      url: currentUrl.toString(),
    };

    let message = link.dataset.messageTemplate || '';
    Object.entries(values).forEach(([key, value]) => {
      message = message.replace(new RegExp(escapeRegExp(`[[${key}]]`), 'g'), String(value));
    });

    if (!/\[\[quantity\]\]/i.test(link.dataset.messageTemplate || '') && !/(quantity|adet)\s*:/i.test(message)) {
      message += `\nQuantity / Adet: ${quantity}`;
    }
    if (!/\[\[options\]\]/i.test(link.dataset.messageTemplate || '')) {
      message += `\nSelected options / Seçimler:\n${values.options}`;
    }

    return `https://wa.me/${phone}?text=${encodeURIComponent(message.trim())}`;
  };

  N.whatsapp = {
    enhance(controller) {
      controller.section.querySelectorAll('[data-g21-whatsapp-link]').forEach((link) => {
        if (!(link instanceof HTMLAnchorElement)) return;
        link.dataset.g21Enhanced = 'true';
        link.href = buildUrl(controller, link);
      });
    },

    onClick(controller, event) {
      const origin = event.target;
      if (!(origin instanceof Element)) return;
      const link = origin.closest('[data-g21-whatsapp-link]');
      if (!(link instanceof HTMLAnchorElement)) return;

      link.href = buildUrl(controller, link);
      const detail = {
        source: link.dataset.source || 'product',
        product: controller.productData?.productTitle || '',
        quantity: getQuantity(controller),
        selections: getSelections(controller),
        href: link.href,
      };

      window.dataLayer?.push({ event: 'g21_whatsapp_click', ...detail });
      document.dispatchEvent(new CustomEvent('g21:whatsapp-click', { detail }));
    },
  };

  document.dispatchEvent(new CustomEvent('g21:modules-ready'));
  N.start?.();
})();
